<template>
    <div class="selectCmcc">
        <el-form :inline="true" :model="searchForm" class="forTbFilter">
            <br />
            <el-form-item label="搜索列表：" class="iccid_textarea_range">
                <el-input type="textarea" :rows="4" placeholder="请输入ICCID 或 业务号MSISDN 或 虚拟号 (每行一个，多个请换行):"
                    v-model="searchForm.iccidStrs">
                </el-input>
            </el-form-item>
            <br/>
            <br/>
            <el-form-item label="范围查询：" class="ICCIDRange">
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidStart" clearable></el-input>
                </el-col>
                <el-col :span="2" class="separate">-</el-col>
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidEnd" clearable></el-input>
                </el-col>                
            </el-form-item>
            <br/>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getAdminCardListHandlers" class="fa fa-search">实时查询卡板信息</el-button>
                <el-button type="primary" @click="toSelect" class="fa fa-search">异步查询信息</el-button>
                <el-button type="primary" @click="toSelectResult" class="fa fa-search">异步结果查询</el-button>
                <el-button type="" @click="reloadData">重置搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border>
            <el-table-column prop="iccid" label="ICCID" width="160px"></el-table-column>
            <el-table-column prop="vriNo" label="虚拟号"  width="120px"></el-table-column>
            <!-- <el-table-column prop="useName" label="在用套餐" width="130px"></el-table-column> -->
            <el-table-column prop="stateName" label="卡状态" width="130px"></el-table-column>
            <el-table-column prop="authName" label="实名状态" width="130px"></el-table-column>
            <!-- <el-table-column prop="onName" label="终端状态" width="130px"></el-table-column> -->
            <el-table-column prop="stopName" label="停机原因" ></el-table-column>
            <el-table-column prop="dongName" label="冻结状态"></el-table-column>
            <el-table-column prop="dongRemark" label="冻结原因"></el-table-column>
            <el-table-column prop="dongTime" label="冻结时间" width="140px"></el-table-column>
        </el-table>



        <el-dialog :append-to-body="true" :title="title" :visible.sync="toSeletFlg" width="600px" @close="toSeletFlg=false"
            :close-on-click-modal="false">
            <p style="color: red;" v-if="searchForm.sysSelect==1">一张卡需3秒查询，请稍后在异步结果中 根据备注查询</p>
            <el-form ref="batchOptForm" :model="batchOptForm" label-width="100px">
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="batchOptForm.remark"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="toSeletFlg=false">取 消</el-button>
                <el-button type="primary" @click="getAdminCardListHandler()">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import { sysRequest } from '@/api/customizedRequest.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            title:'',
            batchOptForm:{
                remark:'',
                sysSelect:'',
            },
            searchForm: {
                remark:'',
                sysSelect:'0',
                phoneNo: '',
                isSold: '',
                cardState: '',
                supplierCode: '',
                basePkgGroup: '',
                agentName: '',
                iccid: '',
                intoNo: '',
                iccidStart: '',
                iccidEnd: '',
                orderBy: '',
                usedFlowRate: null,
                plusFlowRate: null,
                op: '',
                op2: '',
                virtualNo: null
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            simHandleVisibale: false,
            simHandleForm: {
                agentId: ''
            },
            pkgGroup: [],
            branchSupplierOption: [],
            agentListOption: [],
            cardStateOption: [],

            virtualStateArray: [],
            simHandleRules: {
                agentId: [{ required: true, message: '请选择代理商', trigger: 'change' }]
            },
            ops: [
                { label: '等于', value: "=" },
                { label: '大于', value: ">" }
            ],
            batchOptVisible1: false,
            batchOptVisible2: false,
         

            toSeletFlg:false,


        }
    },
    methods: {
        toSelect(){
            this.title='异步查询数据'
            this.searchForm.sysSelect=1;
            this.batchOptForm.remark='';
            this.toSeletFlg=true;
        },
        toSelectResult(){
            this.title='异步结果查询'
            this.searchForm.sysSelect=2;
            this.toSeletFlg=true;
        },
        reloadData(){
            this.searchForm={};
        },
        getAdminCardListHandlers(){
            this.searchForm.sysSelect=0;
            this.getAdminCardListHandler();
        },
        getAdminCardListHandler(sysSelect) {
            this.toSeletFlg=false;
            this.searchForm.remark= this.batchOptForm.remark;
            sysRequest('external/selectBatch', this.searchForm, 'post').then(res => {
                var code = res.data.code;
                if (code == 200) {
                    this.tbpg.tableData=res.data.data;
                    if(this.searchForm.sysSelect=1){
                        this.$message.success(res.data.data);
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            });
        }


    },
    created() {

    }
}
</script>

<style lang="less" scoped>
    .selectCmcc {
        padding: 10px;
        width: 1300px;
        margin:20px auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
        .forTbFilter {
            margin-bottom: 10px;
        }
    }
</style>

